export const getOverageAsPercentage = (el) =>
  Math.round((+el.size * +el.overage) / 100);

export const setAccessToken = (access_token) =>
  localStorage.setItem("access_token", access_token);
export const getAccessToken = () => localStorage.getItem("access_token");
export const clearAccessToken = () => localStorage.removeItem("access_token");
